module.exports = __webpack_public_path__ + "fonts/icofont.f6ab04ae.woff";